<template>
  <Fragment>
    <tr class="transparent-hover">
      <td>
        {{ linkDescription }} #{{ link.id }}
        <px-span-tooltip
          v-if="link.codigoInterno"
          bottom
          text-class="caption"
          :text="`(${link.codigoInterno})`"
          tooltip="Código no ERP"/>
      </td>
      <td>
        {{ linkIdentificador }}
      </td>
      <td class="text-right">
        <px-cotacao-resposta-dialog-view v-if="isCotacao" :cotacao-id="link.id"/>
        <px-compra-detalhes-dialog-view v-if="isCompra" :compra-id="link.id"/>
        <px-aprovacao-solicitacao-detalhes-modal-view v-if="isAprovacaoRequisicao"
                                                      :aprovacao-id="link.id"/>
        <px-requisicao-detalhes-dialog-view v-if="isRequisicao" :requisicao-id="link.id"/>
        <px-aprovacao-detalhes-dialog-view v-if="isAprovacao" :aprovacao-id="link.id"/>
        <px-aprovacao-compra-detalhes-dialog-view v-if="isAprovacaoCompra"
                                                  :aprovacao-id="link.id"/>
        <v-btn icon target="_blank" link :to=linkRedirect>
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </td>
    </tr>
  </Fragment>
</template>
<script>
import { Fragment } from 'vue-frag';
import TipoLink from '@/enums/tipo-link';

const LINK_URL_MAP = {
  COTACAO: link => `/cotacao/${link.id}/respostas`,
  COMPRA: link => `/compra/${link.id}/detalhes`,
  APROVACAO: link => `/aprovacao/${link.id}`,
  APROVACAO_COMPRA: link => `/aprovacao-compra/${link.id}`,
  APROVACAO_REQUISICAO: link => `/aprovacoes-solicitacoes?id=${link.id}`,
  REQUISICAO: link => `/requisicao/${link.id}`,
};

export default {
  props: {
    link: Object,
  },
  computed: {
    isCotacao() {
      return this.link.tipo === TipoLink.keys.COTACAO.key;
    },
    isCompra() {
      return this.link.tipo === TipoLink.keys.COMPRA.key;
    },
    isAprovacao() {
      return this.link.tipo === TipoLink.keys.APROVACAO.key;
    },
    isAprovacaoRequisicao() {
      return this.link.tipo === TipoLink.keys.APROVACAO_REQUISICAO.key;
    },
    isRequisicao() {
      return this.link.tipo === TipoLink.keys.REQUISICAO.key;
    },
    isAprovacaoCompra() {
      return this.link.tipo === TipoLink.keys.APROVACAO_COMPRA.key;
    },
    linkDescription() {
      return TipoLink.keys[this.link.tipo].description || '';
    },
    linkRedirect() {
      return LINK_URL_MAP[this.link.tipo](this.link);
    },
    linkIdentificador() {
      return this.link.identificador ? this.link.identificador : '-';
    },
  },
  components: {
    pxCotacaoRespostaDialogView: () => import('@/modules/cotacao/resposta/views/modal/CotacaoRespostaDialogView.vue'),
    pxCompraDetalhesDialogView: () => import('@/modules/compra/detalhes/CompraDetalhesDialogView.vue'),
    pxAprovacaoDetalhesDialogView: () => import('@/modules/aprovacao/detalhes/AprovacaoDetalhesDialogView.vue'),
    pxAprovacaoSolicitacaoDetalhesModalView: () => import('@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhesModalView.vue'),
    pxRequisicaoDetalhesDialogView: () => import('@/modules/requisicao/detalhes/RequisicaoDetalhesDialogView.vue'),
    pxAprovacaoCompraDetalhesDialogView: () => import('@/modules/aprovacao-compra/detalhes/AprovacaoCompraDetalhesDialogView.vue'),
    Fragment,
  },
};
</script>
